import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

class DeleteRecurrenceTaskConfirmModal extends React.PureComponent {
  render() {
    return (
      <Modal size="tiny" open onClose={this.props.onClose} centered>
        <Modal.Header>Delete Recurrence Task</Modal.Header>
        <Modal.Content>Do you want to delete this occurrence or its series?</Modal.Content>
        <Modal.Actions>
          <Button basic type="button" onClick={this.props.onClose}>
            Cancel
          </Button>
          <Button
            primary
            type="button"
            onClick={() => {
              this.props.deleteTaskRecurrence(this.props.task, true);
              this.props.onClose();
            }}
          >
            Occurrence
          </Button>
          <Button
            primary
            type="button"
            onClick={() => {
              this.props.deleteTaskRecurrence(this.props.task, false);
              this.props.onClose();
            }}
          >
            Series
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default DeleteRecurrenceTaskConfirmModal;
